import React, { useState } from 'react';
import { Phone, ShoppingCart, ChevronDown, Facebook, Linkedin, Instagram } from 'lucide-react';

const SolMartUI = () => {
  const [activeCategory, setActiveCategory] = useState('SOLAR PANELS');

  const products = [
    {
      brand: 'JA SOLAR',
      name: 'JA SOLAR PANEL',
      logo: '/api/placeholder/100/40',
      image: '/api/placeholder/400/500'
    },
    {
      brand: 'LONGI',
      name: 'LONGI SOLAR PANEL',
      logo: '/api/placeholder/100/40',
      image: '/api/placeholder/400/500'
    },
    {
      brand: 'TONGWEI',
      name: 'TONGWEI SOLAR PANEL',
      logo: '/api/placeholder/100/40',
      image: '/api/placeholder/400/500'
    },
    {
      brand: 'ULICA',
      name: 'ULICA SOLAR PANELS',
      logo: '/api/placeholder/100/40',
      image: '/api/placeholder/400/500'
    },
    {
      brand: 'JINKO',
      name: 'JINKO SOLAR PANELS',
      logo: '/api/placeholder/100/40',
      image: '/api/placeholder/400/500'
    },
    {
      brand: 'ASTRONERGY',
      name: 'ASTRONERGY SOLAR',
      logo: '/api/placeholder/100/40',
      image: '/api/placeholder/400/500'
    }
  ];

  const categories = [
    { name: 'Victron Products' },
    { name: 'Victron Solar Inverters' },
    { name: 'Premium Solar Panels' },
    { name: 'Premium Grid Connect Solar Inverters' },
    { name: 'Solar Battery Storage' },
    { name: 'Solar Mounting' },
    { name: 'Electrical Consumables' }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Top Header */}
      <div className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <div className="flex-shrink-0">
              <img src="/api/placeholder/120/40" alt="SolMart" className="h-8" />
            </div>

            {/* Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="#" className="text-gray-700 hover:text-gray-900">Home</a>
              <div className="relative group">
                <button className="flex items-center text-gray-700 hover:text-gray-900">
                  Product <ChevronDown className="ml-1 w-4 h-4" />
                </button>
              </div>
              <div className="relative group">
                <button className="flex items-center text-gray-700 hover:text-gray-900">
                  Company <ChevronDown className="ml-1 w-4 h-4" />
                </button>
              </div>
              <a href="#" className="text-gray-700 hover:text-gray-900">Contact</a>
              <a href="#" className="text-gray-700 hover:text-gray-900">Clearance Sale</a>
            </div>

            {/* Right Section */}
            <div className="flex items-center space-x-4">
              <button className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md flex items-center">
                <ShoppingCart className="w-4 h-4 mr-2" />
                Ebay Store
              </button>
              <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md">
                Price List
              </button>
              <button className="px-4 py-2 bg-orange-500 text-white rounded-md">
                Pay Now
              </button>
              <div className="flex items-center text-orange-500">
                <Phone className="w-4 h-4 mr-2" />
                <div className="flex flex-col">
                  <span className="text-xs">Call Us Today</span>
                  <span className="font-bold">1300 100 234</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Category Icons */}
      <div className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-5 gap-4 py-6">
            {['SOLAR PANELS', 'SOLAR INVERTERS', 'SOLAR BATTERY', 'MOUNTING KITS', 'ELECTRICALS'].map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`flex flex-col items-center p-4 rounded-lg transition-colors ${
                  activeCategory === cat ? 'bg-orange-500 text-white' : 'text-gray-600 hover:bg-gray-50'
                }`}
              >
                <div className="w-12 h-12 mb-2">
                  <img src="/api/placeholder/48/48" alt={cat} className="w-full h-full" />
                </div>
                <span className="text-sm font-medium text-center">{cat}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex gap-8">
          {/* Sidebar Categories */}
          <div className="w-64 flex-shrink-0">
            <h2 className="text-xl font-bold text-gray-900 mb-4">Categories</h2>
            <div className="space-y-2">
              {categories.map((cat) => (
                <a
                  key={cat.name}
                  href="#"
                  className="flex items-center justify-between py-2 px-3 text-gray-700 hover:text-orange-500"
                >
                  <span>{cat.name}</span>
                  <ChevronDown className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Product Grid */}
          <div className="flex-1">
            <div className="grid grid-cols-3 gap-6">
              {products.map((product) => (
                <div key={product.name} className="bg-white rounded-lg shadow-sm overflow-hidden">
                  <div className="p-4 border-b">
                    <img src={product.logo} alt={product.brand} className="h-8" />
                  </div>
                  <div className="p-6">
                    <img src={product.image} alt={product.name} className="w-full h-auto" />
                    <h3 className="text-center mt-4 font-medium text-gray-900">{product.name}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Social Links */}
      <div className="fixed right-0 top-1/2 transform -translate-y-1/2 bg-white shadow-lg rounded-l-lg">
        <div className="flex flex-col p-2 space-y-4">
          <a href="#" className="text-orange-500 hover:text-orange-600">
            <Facebook className="w-6 h-6" />
          </a>
          <a href="#" className="text-orange-500 hover:text-orange-600">
            <Linkedin className="w-6 h-6" />
          </a>
          <a href="#" className="text-orange-500 hover:text-orange-600">
            <Instagram className="w-6 h-6" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default SolMartUI;